import { Popper, PopperProps } from '@mui/material';
import React from 'react';
import './CustomPopper.scss';

interface CustomPopperProps {
  props: PopperProps;
  open: boolean;
}

export const CustomPopper = ({ props, open }: CustomPopperProps) => {

  return (
    <Popper
      {...props}

      sx={{
        display: open ? 'block' : 'none'
      }}
    />
  );
};
